import React from 'react'
import { Alert, FullScreenOverlay, Spinner } from '@ztechapps/webui.util'
import { Container } from 'react-bootstrap'

export const LoadingOverlay = () => {
  return (
    <FullScreenOverlay>
      <Container>
        <Alert type="info">
          <Spinner />
          <h3>Loading, please wait...</h3>
          <small>
            The server is taking some time to perform this operation, please wait for a while. Please do not close this
            web page too.
          </small>
        </Alert>
      </Container>
    </FullScreenOverlay>
  )
}
